// SpecRef: ARCH-005
// Reference: docs/decisions/ARCH-005-ui-error-detection-resilience.md#6-logger-abstraction
// Thin console proxy replacing pino; single upgrade point if structured logging is needed later.
export const logger = {
  info: (msg: string) => console.info(msg),
  error: (msg: string) => console.error(msg),
};
